import { apiClient } from "@/shared/api/client"
import { scenarioPath } from "./keys"

// --- группы и каналы ---

export interface ScenarioChat {
	id: string
	title: string
	type: "channel" | "supergroup" | "group"
	username: string | null
	chatId: string | null
}

export const listScenarioChats = async (id: string) =>
	(await apiClient.get<ScenarioChat[]>(scenarioPath(id, "/chats"))).data

export const createScenarioChat = async (
	id: string,
	body: { title: string; type: ScenarioChat["type"]; username?: string; chatId?: string },
) => (await apiClient.post<ScenarioChat>(scenarioPath(id, "/chats"), body)).data

export const deleteScenarioChat = async (id: string, chatId: string) => {
	await apiClient.delete(scenarioPath(id, `/chats/${chatId}`))
}
